import { useMemo, useCallback, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useWorkWithUs } from "contexts/WorkWithUs.contexts";

const useSpecializations = () => {
    const { t: translate } = useTranslation();
    const {
        dataFields,
        errors,
        updateDataField,
        updateErrors,
        updateStatusError,
    } = useWorkWithUs();

    const isVigilant = useMemo(() => {
        return dataFields.typeOfVacancy?.type === "1";
    }, [dataFields]);

    const [courseType, setCourseType] = useState("");
    const [showAddCourse, setShowAddCourse] = useState(false);
    const [showAddProfessionExperience, setShowAddProfessionExperience] = useState(!dataFields?.experience || dataFields?.experience?.length === 0);
    const [validateCnv, setValidateCnv] = useState(null);
    const [lastRecycle, setLastRecycle] = useState(null);
    const [openModal, setOpenModal] = useState(false);

     const handleCloseModal = useCallback(() => {
        setOpenModal(false);
    }, []);

     const handleChangeText = useCallback(
        ({ target }, item, fn = () => {}) => {
            //console.log(item, {[target.name]: target.value})

        updateDataField(item, {
            ...{ ...dataFields[item], [target.name]: target.value },
        });

        updateErrors(item, {
            ...{ ...errors[item], [target.name]: false },
        });
        updateStatusError(false);
        fn();
        },
        [dataFields, errors, updateDataField, updateErrors, updateStatusError]
    );

    const handleChangeDate = useCallback(
        (date, item, name, fn = () => {}) => {
        updateDataField(item, {
            ...{
            ...dataFields[item],
            [name]: date,
            },
        });

        updateErrors(item, {
            ...{ ...errors[item], [name]: false },
        });
        updateStatusError(false);
        fn();
        },
        [dataFields, updateDataField, updateErrors, updateStatusError, errors]
    );

    const handleSave = useCallback(() => {
      setShowAddCourse(false);
    }, []);

    const handleShowAddCourse = useCallback((courseType) => {
      setCourseType(courseType);
      setShowAddCourse(true);
    }, []);

     const handleHideAddCourse = useCallback(() => {
        setShowAddCourse(false);
    }, []);

    const handleShowProfessionExperience = useCallback(() => {
        setShowAddProfessionExperience(true);
    }, []);

    const handleProfessionExperienceSave = useCallback(() => {
        setShowAddProfessionExperience(false);
    }, []);

     const handleProfessionExperienceHide = useCallback(() => {
        setShowAddProfessionExperience(false);

    }, []);

    const handleChangeFile = useCallback(
        ({ target }) => {
        if (!target.files[0]) {
            return;
        }
        const item = "specializations";
        updateDataField([target.name], {
            file: target.files[0],
            name: target.files[0].name,
        });
        updateErrors(item, {
            ...{ ...errors[item], [target.name]: false },
            ...{ ...errors[item], experience: false },
        });
        updateStatusError(false);
        },
        [updateDataField, updateStatusError, updateErrors, errors]
    );

    const handleRemoveFile = useCallback(
        (name) => {
        updateDataField([name], {});
        },
        [updateDataField]
    );

    const handleRemoveCourse = useCallback(
        (area, name) => {
            const newCourses = dataFields[area]?.filter((item) => item !== name);
            updateDataField(area, newCourses);
        },
        [dataFields, updateDataField]
    );

    const handleRemoveExperience = useCallback(
        (area, obj) => {
            const newExperiences = dataFields[area]?.filter((item) => item !== obj);
            updateDataField(area, newExperiences);

            if(newExperiences.length === 0){
                setShowAddProfessionExperience(true);
            }
        },
        [dataFields, updateDataField]
    );

    const handleChangeCheckbox = useCallback(
        ({ target }) => {
            const checked = target.checked;

            console.log(checked)

            updateDataField([target.name], checked);

            const item = "specializations";
            updateErrors(item, {
                ...{ ...errors[item], experience: false },
            });
            updateStatusError(false);
        },
        [errors, updateDataField, updateErrors, updateStatusError]
    );

    const handleChangeCheckboxPrimeiraVia = useCallback(
        ({ target }, item, fn = () => {}) => {
        const checked = !dataFields?.specializations?.[target.name];

        updateDataField(item, {
            ...{
            ...dataFields[item],
            [target.name]: checked,
            },
        });

        updateErrors(item, {
            ...{ ...errors[item], ...{ 'cnv': false, 'validate_cnv': false, 'cnv_anexo': false } },
        });

        fn();
        },
        [dataFields, errors, updateDataField, updateErrors]
    );

    const initValidateCnv = useCallback(() => {
        setValidateCnv(dataFields?.specializations?.validate_cnv ?? null);
    }, [dataFields?.specializations?.validate_cnv]);

    const initLastRecycle = useCallback(() => {
        setLastRecycle(dataFields?.specializations?.date_lastRecycle ?? null);
    }, [dataFields?.specializations?.date_lastRecycle]);

    useEffect(() => {
        initValidateCnv();
        initLastRecycle();
    }, [initValidateCnv, initLastRecycle]);

    return {
        isVigilant,
        dataFields,
        courseType,
        showAddCourse,
        showAddProfessionExperience,
        errors,
        validateCnv,
        lastRecycle,
        openModal,
        translate,
        handleSave,
        handleShowAddCourse,
        handleHideAddCourse,
        handleShowProfessionExperience,
        handleProfessionExperienceSave,
        handleProfessionExperienceHide,
        handleRemoveCourse,
        handleRemoveExperience,
        handleChangeFile,
        handleRemoveFile,
        handleChangeCheckbox,
        handleChangeCheckboxPrimeiraVia,
        handleChangeText,
        handleChangeDate,
        setValidateCnv,
        setLastRecycle,
        setOpenModal,
        handleCloseModal,
    };
};

export default useSpecializations;
